import { toast } from '@previo/design-system'
import { useUserStore } from '~/store/user'
import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

const loadUser = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  try {
    await useUserStore().load()
  } catch (e) {
    toast.error(e)
  }

  return next()
}

export default loadUser
